import type { CommentTemplateCreateRequest } from '@zendesk/zqa-services/users'

export interface TemplateModalState extends CommentTemplateCreateRequest {
  id?: string
  visible: boolean
}

export enum TemplateType {
  Review = 'review',
  Pin = 'pin',
  Coaching = 'coaching',
}
